/**
 * Builds lease parameters when lease is enabled
 * @returns {Object} Lease parameters object
 */
const buildLeaseParams = (walletDownPaymentFallBack, leaseDownPaymentFallBack, isLeaseEnabled, selectedLeaseTerm, selectedMileage, financeDownPayment, paymentEmphasis, hasUpdatedNDSCalc) => {
  if (!isLeaseEnabled) return {};
  return {
    leaseTerm: selectedLeaseTerm,
    milesPerYear: selectedMileage,
    leaseDownPayment: paymentEmphasis && hasUpdatedNDSCalc ? financeDownPayment || walletDownPaymentFallBack : leaseDownPaymentFallBack
  };
};

/**
 * Builds payment info object for API call
 * @param {boolean} withTaxesAndFees - Whether to include taxes and fees
 * @param walletDownPaymentFallBack
 * @param leaseDownPaymentFallBack
 * @param isLeaseEnabled
 * @param udsLocalStateValues
 * @param paymentEmphasis
 * @param hasUpdatedNDSCalc
 * @param disableTrade
 * @param enableTaxesAndFees
 * @param icoTradeInOffer
 * @param downPaymentValue
 * @returns {Object} Payment info object
 */
const buildPaymentInfo = _ref => {
  let {
    withTaxesAndFees,
    walletDownPaymentFallBack,
    leaseDownPaymentFallBack,
    isLeaseEnabled,
    udsLocalStateValues,
    paymentEmphasis,
    hasUpdatedNDSCalc,
    disableTrade,
    enableTaxesAndFees,
    icoTradeInOffer,
    downPaymentValue
  } = _ref;
  const {
    selectedLoanTerm,
    obfuscatedCredit,
    financeDownPaymentPercentageValue,
    localTradeInValue,
    localAmountOwed,
    vehicleCondition,
    selectedLeaseTerm,
    selectedMileage,
    financeDownPayment
  } = udsLocalStateValues;
  return {
    loanTerm: selectedLoanTerm,
    creditType: obfuscatedCredit,
    downPayment: downPaymentValue,
    downPaymentPercent: financeDownPaymentPercentageValue,
    ...(!disableTrade && {
      tradeIn: {
        value: icoTradeInOffer || localTradeInValue,
        amountOwed: localAmountOwed,
        condition: vehicleCondition
      }
    }),
    ...buildLeaseParams(walletDownPaymentFallBack, leaseDownPaymentFallBack, isLeaseEnabled, selectedLeaseTerm, selectedMileage, financeDownPayment, paymentEmphasis, hasUpdatedNDSCalc),
    includeCash: true,
    includeTaxesFees: enableTaxesAndFees ? withTaxesAndFees : false
  };
};
export { buildPaymentInfo as default };
